import { Link } from "react-router-dom";
import { ChevronRight, CalendarDays } from "lucide-react";

// import Header from "@/components/landing/Header";
import PageHeader from "@/components/common/PageHeader";
import Footer from "@/components/landing/Footer";

export default function LegalLayout({
  title,
  description,
  lastUpdated = "July 2026",
  children,
}) {
  return (
    <div className="min-h-screen bg-white">

      {/* <Header /> */}
      <PageHeader />
      <main>
        {/* Hero */}
        <section className="relative overflow-hidden bg-gradient-to-br from-[#0F2D52] via-[#123864] to-[#1E5AA8] text-white">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.10),transparent_45%)]" />

          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
            {/* Breadcrumb */}
            <nav
              aria-label="Breadcrumb"
              className="flex items-center gap-2 text-sm text-white/70"
            >
              <Link
                to="/"
                className="hover:text-white transition-colors"
              >
                Home
              </Link>

              <ChevronRight className="h-4 w-4" />

              <span className="text-white">{title}</span>
            </nav>

            <div className="mt-6 max-w-3xl">
              <h1 className="font-heading text-4xl md:text-5xl font-extrabold tracking-tight">
                {title}
              </h1>

              {description && (
                <p className="mt-5 text-lg leading-8 text-white/80">
                  {description}
                </p>
              )}

              <div className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-sm text-white/80 backdrop-blur">
                <CalendarDays className="h-4 w-4" />
                <span>Last Updated: {lastUpdated}</span>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20">
            <article className="rounded-3xl bg-white shadow-sm border border-gray-200 p-8 md:p-12">
              <div
                className="
                  prose
                  prose-gray
                  prose-headings:text-[#0F2D52]
                  prose-headings:font-heading
                  prose-headings:font-bold
                  prose-p:text-gray-700
                  prose-p:leading-8
                  prose-li:text-gray-700
                  prose-strong:text-[#0F2D52]
                  prose-a:text-[#1E5AA8]
                  max-w-none
                "
              >
                {children}
              </div>
            </article>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
